import { render } from "./Finances.vue?vue&type=template&id=c213cde6&scoped=true"
import script from "./Finances.vue?vue&type=script&lang=js"
export * from "./Finances.vue?vue&type=script&lang=js"

import "./Finances.vue?vue&type=style&index=0&id=c213cde6&scoped=true&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c213cde6"]])

export default __exports__